import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AuthenticationService } from './services/authentication.service';
import { AuthorizationService } from './services/authorization.service';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';

@NgModule({
  imports: [CommonModule],
  declarations: [AccessDeniedComponent],
  providers: [AuthenticationService, AuthorizationService],
})
export class SecurityModule {}
